const ReceivedReport = () =>
  import(/* webpackChunkName: "received" */ '@/pages/bol/received/index.vue')
const ProcessingReport = () =>
  import(
    /* webpackChunkName: "processing" */ '@/pages/bol/processing/index.vue'
  )

const PaymentQueueReport = () =>
  import(
    /* webpackChunkName: "paymentQueue" */ '@/pages/bol/payment-queue/index.vue'
  )
const PaidReport = () =>
  import(/* webpackChunkName: "paid" */ '@/pages/bol/paid/index.vue')
const BolDetail = () =>
  import(/* webpackChunkName: "bol-detail" */ '@/pages/bol/detail.vue')

export default {
  name: 'BillOfLading',
  path: 'bol',
  meta: {
    label: 'billOfLading'
  },
  component: {
    name: 'BillOfLading',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'ReceivedReport',
      path: 'received',
      meta: {
        label: 'report'
      },
      component: ReceivedReport
    },
    {
      name: 'ProcessingReport',
      path: 'processing',
      meta: {
        label: 'report'
      },
      component: ProcessingReport
    },
    {
      name: 'PaymentQueueReport',
      path: 'payment-queue',
      meta: {
        label: 'report'
      },
      component: PaymentQueueReport
    },
    {
      name: 'PaidReport',
      path: 'paid',
      meta: {
        label: 'report'
      },
      component: PaidReport
    },
    {
      name: 'BolDetail',
      path: ':id',
      meta: {
        label: 'report'
      },
      component: BolDetail
    }
  ]
}
